import React from "react";
import "./BenefitCard.css";
import { ReactComponent as ArrowIcon } from '../../../../assets/images/multiple-devices/Arrow.svg';
import { routePath } from "../../../../constants/Routes";
import { useHistory } from "react-router-dom";
import { 
  DEVICE_ACTIONS, 
  LOCALSESSIONDATAKEYS, 
  UPGRADE_TO_ECOPRO 
} from "../../../../constants/AppConstants";
import { useDispatch } from "react-redux";
import { Upgrade_To_Ecopro_Status } from "../../../../actions/Dashboard";
import { EnrollmentRegisterServiceReset } from "../../../../store/brotherPlus/EnrollmentService/RegisterService/RegisterServiceSlice";
import { FetchUserAccount } from "../../../../actions/UserAccount";
import { getLocalSessionData } from "../../../../utils/Authentication/handleUserSession";
import { getConnectBenefitsLink } from "../../../../constants/AppMethod";

const BenefitCard = ({ title, description, headerIcon, bgColor, cursor = 'none', action = 'none', cname= 'none' }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const UID = getLocalSessionData(LOCALSESSIONDATAKEYS.UID);
  const AZURE_AD_B2C_UID = getLocalSessionData(LOCALSESSIONDATAKEYS.AZURE_AD_B2C_UID);
  const deviceId = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID);

  const handleClick = () => {
    if (action === DEVICE_ACTIONS.CHANGE_PLAN) {
      history.push({
        pathname: routePath.CHANGE_PLAN,
        state: {
          accountClicked: "changePlan",
          data: null,
        },
      });
    }
    if (action === DEVICE_ACTIONS.CANCEL_PLAN) {
      history.push({
        pathname: routePath.UPDATE_ACCOUNT_CONFIRMATION,
        state: {
          accountClicked: "cancelPlan",
          data: null,
        },
      });
    }
    if (action === UPGRADE_TO_ECOPRO) { 
      dispatch(Upgrade_To_Ecopro_Status(true));
      dispatch(EnrollmentRegisterServiceReset());
      dispatch(FetchUserAccount(AZURE_AD_B2C_UID, UID, deviceId, UPGRADE_TO_ECOPRO));
      history.push({ pathname: routePath.ROLE_REDIRECTION, state: { 'upgradeTo_EcoProProcess': true } });
    }
    if (action === DEVICE_ACTIONS.CONNECT_BENEFITS) {
      let connectBenefitsUrl = getConnectBenefitsLink();
      window.open(connectBenefitsUrl, '_blank');
    }
  };

  return (
    <div
      className={`benefit_card_wrapper ${cname}`}
      style={{
        backgroundColor: bgColor
      }}
      onClick={handleClick}
    >
      <div className="benefit_card_header">
        <div className="benefit_card_titleSection">
          {headerIcon &&
            <span className="benefit_card_icon">
              <img src={headerIcon} title={`${title}-icon`} alt={`${title}-icon`} />
            </span>
          }
          <h3 className="benefit_card_title">{title}</h3>
          {ArrowIcon && <span className="benefit_card_arrow"><ArrowIcon /></span>}
        </div>
      </div>
      <p className="benefit_card_description">{description}</p>
    </div>
  );
};

export default BenefitCard;